import { agendaItemRepo } from "@/repositories/agendaItemRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";
import { teamFilter, type TeamIdOrOrg } from "./common";

export const useGetAgendaItem = (tenantId: string, agendaItemId: string) => {
  return useObservable(
    () => agendaItemRepo.get(tenantId, agendaItemId),
    [tenantId, agendaItemId]
  );
};

export const useAgendaItemList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () => agendaItemRepo.list(tenantId).pipe(map(teamFilter(teamId))),
    [tenantId, teamId]
  );
};
